<script>
  import { fade } from "svelte/transition";
</script>

<div
  transition:fade={{ duration: 300 }}
  id="loadingPage"
  class="fixed top-0 left-0 z-50 flex items-center justify-center w-screen h-screen p-10 text-center bg-white bg-opacity-75"
>
  <span
    class="p-4 font-bold text-gray-600 transition-all duration-100 ease-in-out bg-white rounded-full shadow-xl animate-bounce"
  >
    <img
      src="./assets/logo/logo_icon.svg"
      alt="Mikhub Loading"
      class="w-20 h-20 mx-auto animate-spin"
      width="50"
      height="50"
    />
  </span>
</div>
